<div class="side-menu flex-column">

    <ui-logo
        [defaultLogo]="valuesService.centralLogos.app"
        [clickable]="true"
        [routerLink]="'/'"
        routerLinkActive="active"
        (click)="closeDrawers()"
        class="sidemenu-logo d-none d-md-flex justify-content-center align-items-center">
    </ui-logo>

    <nav ui-list highlights="true" type="nav" class="unbordered">
        <ng-container *ngTemplateOutlet="menuSection; context: { $implicit: internalSection, separator: internalSection.length }"></ng-container>
        <ng-container *ngTemplateOutlet="menuSection; context: { $implicit: servicesSection, separator: servicesSection.length }"></ng-container>
        <ng-container *ngTemplateOutlet="menuSection; context: { $implicit: otherSection, separator: false }"></ng-container>
    </nav>

    <connection-status class="my-auto"
        [offline]="connectivityProblems()"
        *ngIf="connectivityProblems()">
    </connection-status>

    <div class="footer c1" *ngIf="footer">

        <button id="changeLanguages"
                [disabled]="!footer.showChangeLanguage"
                ui-button model="link"
                size="sm"
                (click)="openChangeLanguageModal()">
            <div class="d-flex align-items-center">
                <img [src]=footer.lang.flag [alt]="footer.lang.alt" class="mr-1" width="18" height="18">
                <span>{{ footer.lang.label }}</span>
            </div>
        </button>

        <p class="my-1">
            <!-- NOT REQUIRED FOR SOURCENEXT -->
            <!-- <a *ngIf="footer.terms" id="a_1580325930" ui-button model="link" size="sm" target="_blank" rel="noreferrer" [href]="privacyLinkComponent" (click)="goToTermsAndPrivacy($event)">
                {{'main.privacy_policy' | translate}}
            </a> |
            <a id="a_1641475253" *ngIf="configService.getCookieConsent()" ui-button model="link" size="sm" (click)="openCookieSettings($event)">
                {{"main.cookie.settings.title" | translate}}
            </a>
            <br /> -->
            <a *ngIf="configService.config.thirdparty" id="a_1630333094" ui-button model="link" size="sm" rel="noreferrer" [href]="valuesService.centralPaths.services.thirdparty.path" target="_blank">
                {{"main.thirdparty.title" | translate}}
            </a>

        </p>

        <p class="copyright m-0">&#169; {{ footer.copyright.year}} SOURCENEXT</p>

        <p *ngIf="configService.config.poweredBy" class="powered-by-Bitdefender"></p>
    </div>

</div>

<!-- side menu section template (internal paths) -->
<ng-template #menuSection let-section let-separator="separator">
    <ng-container *ngFor="let item of section">
        <a ui-list-item
            id="a_{{item.timestampId}}"
            (click)="item.action($event)"
            [routerLink]="item.isExternal ? null : item.path"
            routerLinkActive="active"
            [ngClass]="{'campaign': item.campaign?.show, 'unavailable': !item.available}">

            <ui-icon *ngIf="item.icon" shape="icon" size="24"
                [type]="item.icon.type"
                [icon]="item.icon.icon"
                [ngClass]="{'withCornerDot': item.requiresAttention}">
            </ui-icon>

            <span class="label b2">{{item.productName ?? (item.textKey | translate)}}</span>

            <ui-tag *ngIf="item.isNew"
                id="tag_{{item.timestampId}}"
                [type]="item.available ? 'filled' : 'outline'"
                color="success">
                {{'devices.new' | translate}}
            </ui-tag>

            <span class="campaign-tag" *ngIf="item.campaign?.show">
                <ui-icon *ngIf="item.campaign.icon"
                    [type]="item.campaign.icon.type"
                    [icon]="item.campaign.icon.name"
                    shape="icon" size="58" class="m-0"></ui-icon>
            </span>

            <ui-icon *ngIf="item.isExternal" type="general" icon="open" shape="icon" size="16"></ui-icon>
        </a>
    </ng-container>

    <hr ui-list-item *ngIf="separator" role="separator"/>
</ng-template>
